<template>
  <div>

    <!-- Footer -->
    <!-- <footer>
      <div class="container-fluid">
        <div class="footer-content mb-2">
          <div class="footer-logo">
            <div class="bg-title mb-2">SWAC</div>
            <div class="text text-uppercase">SouthWestern Accreditation Council </div>
          </div>
          <div class="footer-links">
            
            <router-link class="footer-link"
              v-if="(header[0]) ? header[0].status : false"
              to="/accreditations">Accreditation</router-link>

            <router-link class="footer-link"
              v-if="(header[8]) ? header[8].status : false"
              to="/our-certificates">Certification</router-link>

            <router-link class="footer-link"
              v-if="(header[3]) ? header[3].status : false"
              to="/about">About</router-link>

            <router-link class="footer-link"
              v-if="(header[1]) ? header[1].status : false"
              to="/programs">Programs</router-link>

            <router-link class="footer-link"
              v-if="(header[2]) ? header[2].status : false"
              to="/memberships">Membership</router-link>

            <router-link class="footer-link"
              v-if="(header[4]) ? header[4].status : false"
              to="/contact">Contact us</router-link>

            <router-link class="footer-link"
              v-if="(header[7]) ? header[7].status : false"
              to="/online-trainings">Online Training</router-link>

            <router-link class="footer-link"
              v-if="(header[6]) ? header[6].status : false"
              to="/events">Events & Conferences</router-link>

            <router-link v-for="(pg, idx) in pages" :key="idx"
                :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}</router-link>

          </div>
        </div>
        <div class="footer-bottom d-flex justify-content-between">
          <div class="fb-text">2021 All Rights Reserved © SWAC SouthWestern Accreditation Council 
            <router-link class="ml-2"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link>
          </div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">

              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </footer> -->
    <!-- Footer -->

    <footer>
      <div class="container-fluid">
        <div class="footer-top">
          <div class="footer-links">
              <router-link class="footer-link"
                v-if="(header[0]) ? header[0].status : false"
                to="/accreditations">Accreditation</router-link>

              <router-link class="footer-link"
                v-if="(header[8]) ? header[8].status : false"
                to="/our-certificates">Certification</router-link>

              <router-link class="footer-link"
                v-if="(header[3]) ? header[3].status : false"
                to="/about">About</router-link>

              <router-link class="footer-link"
                v-if="(header[1]) ? header[1].status : false"
                to="/programs">Programs</router-link>

              <router-link class="footer-link"
                v-if="(header[2]) ? header[2].status : false"
                to="/memberships">Membership</router-link>

              <router-link class="footer-link"
                v-if="(header[4]) ? header[4].status : false"
                to="/contact">Contact us</router-link>

              <router-link class="footer-link"
                v-if="(header[7]) ? header[7].status : false"
                to="/online-trainings">Online Training</router-link>

              <router-link class="footer-link"
                v-if="(header[6]) ? header[6].status : false"
                to="/events">Events &amp; Conferences</router-link>

              <router-link v-for="(pg, idx) in pages" :key="idx"
                  :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                  class="footer-link"
                  :class="(pg.has_footer) ? '' : 'hidden' ">
                  {{ pg.title }}</router-link>

            </div>

            <div class="footer-logo d-flex align-items-center">
              <div class="fl-box">
                <img :src="logo.logo" class="img-fluid" alt="" />
              </div>
              <div class="footer-text">
                American <br /> Management <br /> Institute 
              </div>
            </div>
        </div>
        <div class="footer-bottom">
          <div class="text">2021 All Rights Reserved © AMI</div>
          <div class="socialmedia-footer d-flex align-items-center">
            <router-link to="/privacy" class="privacy-btn">Privacy Policy</router-link>
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">
              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
/* Footer */
footer {
  background: #001157;
}
.footer-top {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.footer-links {
  display: flex;
  flex-wrap: wrap;
}
.footer-link {
  width: 30%;
  margin-bottom: 13px;
  font-size: 20px;
  color: #9b9b9b;
}
.fl-box img {
  width: 150px;
}
.footer-text {
  padding-left: 25px;
  color: #fff;
  font-weight: bold;
  font-size: 26px;
  line-height: 1;
  text-transform: uppercase;
}
.footer-bottom {
  border-top: 1px solid #fff;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.social-icon {
  line-height: 1;
  margin-left: 15px;
}
.social-icon i {
  color: #fff;
}
.social-icon i:hover {
  color: #b6b5b5;
}
.follow-text {
  color: #fff;
  margin-left: 30px;
  line-height: 1;
  font-size: 15px;
}
.footer-socialmedia {
  line-height: 1;
  color: #fff;
}
.privacy-btn {
  line-height: 1;
  font-size: 15px;
  color: #fff;
}
.privacy-btn:hover {
  text-decoration: underline !important;
}

footer .bg-title {
  color: #fff;
  font-size: 45px;
}
footer .text {
  color: #fff;
  font-size: 14px !important;
}
.footer-logo .text {
  font-size: 12px;
}
.footer-links {
  padding: 15px 0;
}
.footer-link:hover {
  color: #fff;
  text-decoration: underline !important;
}
.fb-text {
  font-size: 13px;
  display: flex;
  align-items: center;
}
.fb-text a {
  text-decoration: underline !important;
}
.fb-text a:hover {
  color: #fff;
}
.socialmedia i {
  font-size: 13px;
  margin-left: 8px;
}
/* Footer */

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  .footer-top {
    display: block;
  }
  .footer-link {
    width: 50%
  }
  .footer-bottom {
    padding: 14px 0;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .footer-top {
    flex-wrap: wrap;
  }  
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .footer-top {
    flex-wrap: wrap;
  } 
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  
}

</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      logo: [],
      pages: [],
    };
  },
  created() {

      axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
        this.logo = res.data.logo;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
      
  },
};
</script>
